import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import { PageTabRail } from '../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../components/router/router-tabbed-navigation';
import { TafReportTable } from '../../../../../../../../../features/fees/taf-report/taf-report-table';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/taf-report/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingFinanceMiddleMoney,
      label: 'TAF Report',
      order: 1,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingFinanceMiddleMoney>,
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'taf-report',
        label: 'Middle Money',
        to: '/clearing/finance/middle-money/taf-report',
      }),
    }) satisfies AggregateBreadcrumb,
  component: TafReport,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingFinanceMiddleMoney}
    />
  );
}

function TafReport() {
  return (
    <PageLayout>
      <PageLayout.Section>
        <TafReportTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
